<template>
  <div
    class="fixed bottom-0 left-0 right-0 z-50 bg-[#F9F9F9] flex justify-between items-start gap-3 p-[11px]"
    :style="safeAreaStyle"
  >
    <!-- Info del agente -->
    <div class="flex gap-3 text-white text-left min-w-0 flex-shrink">
      <img
        src="@/assets/imgs/broker_default.png"
        class="w-16 h-16 object-cover object-center rounded-full flex-shrink-0"
        alt="Foto de perfil"
      />
      <div class="flex flex-col justify-center min-w-0">
        <p class="truncate max-w-[13ch] text-base text-gray-900 font-medium leading-tight">{{ fullName }}</p>
        <p class="truncate max-w-[15ch] text-sm text-gray-900 leading-tight">Prospecto</p>
      </div>
    </div>

    <!-- Botones -->
    <div class="flex gap-2 mt-2 flex-shrink-0">
      <!-- Llamar -->
      <a
        :href="`tel:+${(props.contactData.country_code || '52').replace('+', '')}${props.contactData.phone}`"
        class="group text-tuin-100 border border-tuin-100 hover:bg-tuin-100 transition-colors flex items-center justify-center w-[50px] h-[50px] rounded-lg"
        @click="callActionLog(65, `El asesor ${asesor_name} con id ${asesor_id} contacto a su prospecto ${props.contactData.name} ${props.contactData.last_name} ${props.contactData.second_last_name} con id ${props.contactData.id} via llamada`)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="w-[24px] h-[24px]">
          <path d="M16.629 13.891L17.085 13.438L16.026 12.374L15.572 12.827L16.629 13.891ZM18.614 13.248L20.525 14.287L21.24 12.969L19.33 11.931L18.614 13.248ZM20.892 16.351L19.472 17.764L20.529 18.827L21.949 17.415L20.892 16.351ZM18.606 18.218C17.156 18.354 13.406 18.233 9.34399 14.195L8.28599 15.258C12.718 19.665 16.937 19.881 18.746 19.712L18.606 18.218ZM9.34399 14.195C5.47299 10.345 4.83099 7.10796 4.75099 5.70296L3.25299 5.78796C3.35299 7.55596 4.14799 11.144 8.28599 15.258L9.34399 14.195ZM10.719 8.01496L11.006 7.72896L9.94999 6.66596L9.66299 6.95096L10.719 8.01496ZM11.234 4.09396L9.97399 2.40996L8.77299 3.30996L10.033 4.99296L11.234 4.09396ZM5.73299 2.04296L4.16299 3.60296L5.22099 4.66696L6.78999 3.10696L5.73299 2.04296ZM10.191 7.48296C9.66099 6.95096 9.66099 6.95096 9.66099 6.95296H9.65899L9.65599 6.95696C9.60847 7.00487 9.56592 7.05748 9.52899 7.11396C9.47499 7.19396 9.41599 7.29896 9.36599 7.43196C9.24427 7.77529 9.21394 8.14437 9.27799 8.50296C9.41199 9.36796 10.008 10.511 11.534 12.029L12.592 10.965C11.163 9.54496 10.823 8.68096 10.76 8.27296C10.73 8.07896 10.761 7.98296 10.77 7.96096C10.776 7.94763 10.776 7.94563 10.77 7.95496C10.7611 7.96876 10.751 7.9818 10.74 7.99396L10.73 8.00396L10.72 8.01296L10.191 7.48296ZM11.534 12.029C13.061 13.547 14.21 14.139 15.076 14.271C15.519 14.339 15.876 14.285 16.147 14.184C16.2988 14.1284 16.4406 14.0487 16.567 13.948L16.617 13.903L16.624 13.897L16.627 13.894L16.628 13.892C16.628 13.892 16.629 13.891 16.1 13.359C15.57 12.827 15.573 12.826 15.573 12.826L15.575 12.824L15.577 12.822L15.583 12.817L15.593 12.807L15.631 12.777C15.6403 12.771 15.638 12.7716 15.624 12.779C15.599 12.788 15.501 12.819 15.304 12.789C14.89 12.725 14.02 12.385 12.592 10.965L11.534 12.029ZM9.97399 2.40896C8.95399 1.04896 6.94999 0.83296 5.73299 2.04296L6.78999 3.10696C7.32199 2.57796 8.26599 2.63296 8.77299 3.30996L9.97399 2.40896ZM4.75199 5.70396C4.73199 5.35796 4.89099 4.99596 5.22099 4.66796L4.16199 3.60396C3.62499 4.13796 3.20199 4.89396 3.25299 5.78796L4.75199 5.70396ZM19.472 17.764C19.198 18.038 18.902 18.192 18.607 18.219L18.746 19.712C19.481 19.643 20.082 19.273 20.53 18.828L19.472 17.764ZM11.006 7.72896C11.991 6.74996 12.064 5.20296 11.235 4.09496L10.034 4.99396C10.437 5.53296 10.377 6.23996 9.94899 6.66696L11.006 7.72896ZM20.526 14.288C21.343 14.732 21.47 15.778 20.893 16.352L21.951 17.415C23.291 16.082 22.878 13.859 21.241 12.97L20.526 14.288ZM17.085 13.439C17.469 13.057 18.087 12.963 18.615 13.249L19.331 11.932C18.247 11.342 16.903 11.505 16.027 12.375L17.085 13.439Z" class="fill-tuin-100 group-hover:fill-white"/>
        </svg>
      </a>

      <!-- WhatsApp -->
      <a
        :href="`https://wa.me/${(props.contactData.country_code || '52').replace('+', '')}${props.contactData.phone}?text=${encodeURIComponent(`Hola ${props.contactData.name}. Soy ${asesor_name}, asesor inmobiliario. Te escribo por tu interés en una de mis propiedades. ¿Te gustaría conocer más detalles o agendar una visita?`)}`" 
        target="_blank" 
        class="group text-what border border-what hover:bg-what transition-colors flex items-center justify-center w-[50px] h-[50px] rounded-lg"
        @click="callActionLog(66, `El asesor ${asesor_name} con id ${asesor_id} contacto a su prospecto ${props.contactData.name} ${props.contactData.last_name} ${props.contactData.second_last_name} con id ${props.contactData.id} via whatsapp`)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="w-[24px] h-[24px]">
          <path d="M19.05 4.91005C18.1331 3.98416 17.041 3.25002 15.8375 2.75042C14.634 2.25081 13.3431 1.99574 12.04 2.00005C6.57999 2.00005 2.12999 6.45005 2.12999 11.9101C2.12999 13.6601 2.58999 15.3601 3.44999 16.8601L2.04999 22.0001L7.29999 20.6201C8.74999 21.4101 10.38 21.8301 12.04 21.8301C17.5 21.8301 21.95 17.3801 21.95 11.9201C21.95 9.27005 20.92 6.78005 19.05 4.91005ZM12.04 20.1501C10.56 20.1501 9.10999 19.7501 7.83999 19.0001L7.53999 18.8201L4.41999 19.6401L5.24999 16.6001L5.04999 16.2901C4.22754 14.9771 3.79091 13.4593 3.78999 11.9101C3.78999 7.37005 7.48999 3.67005 12.03 3.67005C14.23 3.67005 16.3 4.53005 17.85 6.09005C18.6176 6.85392 19.2259 7.7626 19.6396 8.76338C20.0533 9.76417 20.2642 10.8371 20.26 11.9201C20.28 16.4601 16.58 20.1501 12.04 20.1501ZM16.56 13.9901C16.31 13.8701 15.09 13.2701 14.87 13.1801C14.64 13.1001 14.48 13.0601 14.31 13.3001C14.14 13.5501 13.67 14.1101 13.53 14.2701C13.39 14.4401 13.24 14.4601 12.99 14.3301C12.74 14.2101 11.94 13.9401 11 13.1001C10.26 12.4401 9.76999 11.6301 9.61999 11.3801C9.47999 11.1301 9.59999 11.0001 9.72999 10.8701C9.83999 10.7601 9.97999 10.5801 10.1 10.4401C10.22 10.3001 10.27 10.1901 10.35 10.0301C10.43 9.86005 10.39 9.72005 10.33 9.60005C10.27 9.48005 9.76999 8.26005 9.56999 7.76005C9.36999 7.28005 9.15999 7.34005 9.00999 7.33005H8.52999C8.35999 7.33005 8.09999 7.39005 7.86999 7.64005C7.64999 7.89005 7.00999 8.49005 7.00999 9.71005C7.00999 10.9301 7.89999 12.1101 8.01999 12.2701C8.13999 12.4401 9.76999 14.9401 12.25 16.0101C12.84 16.2701 13.3 16.4201 13.66 16.5301C14.25 16.7201 14.79 16.6901 15.22 16.6301C15.7 16.5601 16.69 16.0301 16.89 15.4501C17.1 14.8701 17.1 14.3801 17.03 14.2701C16.96 14.1601 16.81 14.1101 16.56 13.9901Z" class="fill-what group-hover:fill-white"/>
        </svg>
      </a>

      <a 
        :href="`mailto:${props.contactData.email}?subject=${encodeURIComponent('Consulta sobre propiedad en Tuin')}&body=${encodeURIComponent(`Hola ${props.contactData.name}. Soy ${asesor_name}, asesor inmobiliario. Te escribo por tu interés en una de mis propiedades. ¿Te gustaría conocer más detalles o agendar una visita?`)}`"
        class="group text-gray-800 border border-gray-800 hover:bg-gray-800 hover:text-white transition-colors flex items-center justify-center w-[50px] h-[50px] rounded-lg"
        @click="callActionLog(67, `El asesor ${asesor_name} con id ${asesor_id} contacto a su prospecto ${props.contactData.name} ${props.contactData.last_name} ${props.contactData.second_last_name} con id ${props.contactData.id} via email`)"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-[24px] h-[24px]">
          <path d="M4 7.00005L10.2 11.65C11.2667 12.45 12.7333 12.45 13.8 11.65L20 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round"></rect>
        </svg>
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import axios from "axios";

const store = useStore();
const session = computed(() => store.getters.getUserSession);

let asesor_name = session.value.name; 
let asesor_id = session.value.id;

const props = defineProps({
  contactData: {
    type: Object,
    default: () => ({}),
    required: true
  },
});

const safeAreaStyle = computed(() => ({
  paddingLeft: 'max(env(safe-area-inset-left), 11px)',
  paddingRight: 'max(env(safe-area-inset-right), 11px)',
}));

const fullName = computed(() => {
  const { name = '', last_name = '', second_last_name = '' } = props.contactData;
  return `${name} ${last_name} ${second_last_name}`;
});

async function callActionLog(type_action, detail = ''){

  let link = `${process.env.VUE_APP_API_BASE_URL}/event/add_log`;
  let param_analytics = {
    "property_id":          null, // Se puede agregar como prop si es necesario
    "user_id":              asesor_id,
    "agent_id":             null,
    "activity_id":          type_action,
    "description":          detail,          
  }

  let options = {
    headers: {
      "Content-Type": "application/json"
    },
  };

  try {
    const response = await axios.post(link, param_analytics, options);

    if (response.status == 401) {
      //console.log("Hay que sacarlo de la sesion ");
    }

    if (response.status == 200) {
      //console.log(response);
    }
      
  } catch (error) {
    console.error("Error fetching data:", error);
  }

}

</script> 